/**
 * React Navbar.tsx mega menü — kategori panelleri (hover / focus).
 */
(function () {
  var lastId = '0';

  function init() {
    var root = document.getElementById('mega-menu');
    if (!root) return;

    var primaries = root.querySelectorAll('[data-mega-primary]');
    if (!primaries.length) return;

    var subs = root.querySelectorAll('[data-mega-sub]');
    var visuals = root.querySelectorAll('[data-mega-visual]');
    var copies = root.querySelectorAll('[data-mega-copy]');

    var firstPrimary = primaries[0];
    var defaultId = firstPrimary ? firstPrimary.getAttribute('data-mega-primary') : '0';
    lastId = defaultId;

    function setCat(id) {
      lastId = id || defaultId;
      primaries.forEach(function (btn) {
        var on = btn.getAttribute('data-mega-primary') === lastId;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('text-white', on);
        btn.classList.toggle('translate-x-4', on);
        btn.classList.toggle('text-gray-600', !on);
        btn.classList.toggle('hover:text-gray-400', !on);
        var arw = btn.querySelector('[data-mega-arrow-wrap]');
        if (arw) {
          if (on) {
            arw.classList.remove('opacity-0', '-translate-x-2', 'pointer-events-none');
          } else {
            arw.classList.add('opacity-0', '-translate-x-2', 'pointer-events-none');
          }
        }
      });
      subs.forEach(function (el) {
        el.classList.toggle('hidden', el.getAttribute('data-mega-sub') !== lastId);
      });
      visuals.forEach(function (el) {
        var match = el.getAttribute('data-mega-visual') === lastId;
        el.classList.toggle('hidden', !match);
        el.setAttribute('aria-hidden', match ? 'false' : 'true');
      });
      copies.forEach(function (el) {
        var match = el.getAttribute('data-mega-copy') === lastId;
        el.classList.toggle('hidden', !match);
      });
    }

    primaries.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        setCat(btn.getAttribute('data-mega-primary'));
      });
      btn.addEventListener('focus', function () {
        setCat(btn.getAttribute('data-mega-primary'));
      });
    });

    setCat(lastId);

    document.body.addEventListener('mega-menu-opened', function () {
      setCat(lastId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
